import {QueryValue} from '.';
import {Operator, OperatorMapping} from '../../../Searches/consts/operators';
import {extractForm} from '../searchesList';
import {DateUSto14} from '../../../../_shared/GWTBridge/invoke/common';

export type filterType = {value: any; operator: Operator};
export const dateUS14 = 'MM/DD/YY hh:mm a';

export function serialize(queryValue: QueryValue): filterType {
    const {fromval, toval, op} = queryValue;
    let operator;
    let min = fromval;
    let max = toval;
    if (!fromval && !toval) {
        return {
            value: {
                min: '',
                max: ''
            },
            operator: op === '<>' ? Operator.NotEmpty : Operator.Empty
        };
    }
    if ((fromval && toval) || (!fromval && !toval)) {
        operator = Operator.Between;
    } else if (fromval) {
        if (!op || op === '=') {
            operator = Operator.Equals;
        } else if (op === '>' || op === '>=') {
            operator = Operator.Later;
        } else if (op === '<' || op === '<=') {
            max = fromval;
            min = '';
            operator = Operator.Before;
        } else if (op === '<>') {
            operator = Operator.NotEquals;
        }
    } else {
        operator = Operator.Before;
    }
    return {
        value: {
            min: min,
            max: max
        },
        operator: operator
    };
}

export function deserialize({operator, value}: filterType, format): Partial<QueryValue> {
    const needTranslation = format === dateUS14;
    if (operator === Operator.Empty || operator === Operator.NotEmpty) {
        return {
            fromval: '',
            toval: '',
            op: OperatorMapping[operator]
        };
    }
    return {
        fromval:
            operator !== Operator.Before && value
                ? needTranslation
                    ? DateUSto14(value.min)
                    : value.min
                : '',
        toval:
            (operator === Operator.Before || operator === Operator.Between) && value
                ? needTranslation && value.max
                    ? DateUSto14(value.max)
                    : value.max
                : '',
        op: OperatorMapping[operator]
    };
}

export function serializeDateOptions(data) {
    const form = extractForm(data);
    if (form) {
        const choose = form.Choose[0].ChooseLine;
        const date = form.QueryDates[0].Date;
        for (const idx in choose) {
            if (!choose[idx].retval) {
                choose[idx].retval = choose[idx].str1;
            }
            Object.assign(choose[idx], date[idx]);
        }
        return choose.map(d => ({
            value: d.retval,
            label: d.str1,
            idate: d.idate,
            date: d.date
        }));
    }
    return null;
}
